import React, { useContext } from 'react'
import { t } from 'i18next'
import { Button, Card, Tag } from 'antd'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import GlobalContext from '../GlobalContext'

const stateMessage = (slot, box) => {
  return (
    <div >
      <div>{box.name} - {box.interphone}</div>
      <div>{dayjs(slot.begin_date).format('H[h]mm')}-${dayjs(slot.end_date).format('H[h]mm')}</div>
      <div>{slot.digicode}</div>
    </div>
  )
}

export default function SlotCard ({ slot }) {
  const { boxes } = useContext(GlobalContext)

  const title = (<div style={{ padding: '1em 0' }}>
    <div style={{ color: t(`Admin.Slot.stateColor.${slot.state}`) }}>
      {slot.name}
    </div>
    <div><Tag color={t(`Admin.Slot.stateColor.${slot.state}`)} >{t(`Admin.Slot.state.${slot.state}`)}</Tag></div>
    <div>+{slot.phone}</div>

  </div>)
  return (
    <Card title={title}
      actions={[
        <Link key='edit' to={`/admin/slots/${slot.id}?from=list`}><Button>Edition</Button></Link>
      ]}>
      {stateMessage(slot, boxes.find(box => box.id === slot.box_id))}
    </Card>
  )
}
